import styled from "styled-components";
import theme from "../../theme/theme";

const Button = styled.button`
  border: none;
  background-color: inherit;
  cursor: pointer;
  color: ${theme.colors.primary};
  text-decoration: underline;
  font-size: 15px;
  margin-left: 5px;
  margin-top: ${(props) => (props.isMarginTopNeeded ? "-18px" : "0px")};
`;

const EditButton = ({ actionOnClick, isMarginTopNeeded = true }) => {
  return (
    <Button
      className="editButton"
      onClick={actionOnClick}
      isMarginTopNeeded={isMarginTopNeeded}
    >
      Edit
    </Button>
  );
};

export default EditButton;
